import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, inject } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { BreakpointService } from 'src/app/services/breakpoint.service';
import { MapFilter } from 'src/app/types/map-filter';
import { QueryUnlocodes } from 'src/app/types/query-unlocode';

/**
 * map filter based on material chips (listbox and options)
 * @class MapFilterComponent
 * @typedef {MapFilterComponent}
 */
@Component( {
    imports: [MatChipsModule, MatIconModule, NgFor, NgIf],
    selector: 'riege-map-filter',
    templateUrl: './map-filter.component.html',
    styleUrls: ['./map-filter.component.scss'],
    standalone: true
} )
export class MapFilterComponent {
    /** requires list of button definition */
    @Input( { required: true } ) buttons: MapFilter[] = [];
    /** event emitter */
    @Output() buttonClicked = new EventEmitter();
    /** reference on selected filter */
    selectedID = '';

    #breakpointService = inject( BreakpointService );
    isMobile = computed( () => this.#breakpointService.currentScreenSize() === 'XSmall' );

    /**
     * helper function to react on selection change events
     * @param selection list of selected options, emits when selection changed
     */
    selectionChanged( selection: any ) {
        let query = {} as QueryUnlocodes;
        if ( selection.source.value.length > 0 ) {
            query = {
                ...query,
                junctionTypes: selection.source.value.join()
            };
        }
        this.buttonClicked.emit( { ...query } );
    }
}
